import { z } from 'zod'

export const INTERVIEW_AGENT = 'interview'
export const CUSTOM_AGENT = 'custom'
export const SALES_AGENT = 'sales'

export const agentType = z.enum([INTERVIEW_AGENT, CUSTOM_AGENT, SALES_AGENT])

export type AgentType = z.infer<typeof agentType>
